import { SnackBarService } from './../../../../../shared/cw-utils/snackbar.service';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { DomSanitizer } from '@angular/platform-browser';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { ChatPanelService } from 'app/layout/components/chat-panel/chat-panel.service';
import { Message, MessagePage, Profile, ProfileChatTo } from '../../../../../shared/cw-backend/models/security/user/profile';
import { ProfileProvider } from '../../../../../shared/cw-backend/providers/security/profile/profile.provider';
import { RolePermissionService } from '../../../../../shared/cw-services/role/role-permission.service';
import { CwUtils } from 'cw-utils';
import { TypeHospitalization, WebSocketService } from 'cw-backend';
import { PageVisibilityService } from '../../../../../shared/cw-utils/PageVisibilityService';
import { MatDialog } from '@angular/material/dialog';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';


@Component({
    selector: "chat-panel",
    templateUrl: "./chat-panel.component.html",
    styleUrls: ["./chat-panel.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatPanelComponent implements OnInit, AfterViewInit, OnDestroy {

    /**
     * Quantidade de mensagens carregadas por pagina do historico.
     */
    static readonly MESSAGE_PAGE_SIZE = 100;

    profileList = new Array<ProfileChatTo>();
    chat = new Array<Message>();
    selectedProfile: ProfileChatTo;
    sidebarFolded: boolean;
    user: any;
    profile: Profile;

    showChat = false;
    chatSearch: any;
    searchText: string;

    isLogged = false;
    isSending = false;

    /**
     * Ainda existe historico anterior a pagina carregada?
     */
    hasMoreMessages = true;

    /**
     * Ha uma pagina de mensagens em carregamento?
     */
    loadingMessages = false;

    @ViewChild("replyForm")
    private _replyForm: NgForm;

    @ViewChild("replyInput")
    private _replyInput: ElementRef;

    @ViewChildren(FusePerfectScrollbarDirective)
    private _fusePerfectScrollbarDirectives: QueryList<FusePerfectScrollbarDirective>;

    // Private
    private _chatViewScrollbar: FusePerfectScrollbarDirective;
    private _unsubscribeAll: Subject<any>;

    /**
     * Descarta respostas de paginas que nao correspondem mais a conversa aberta.
     */
    private _messagesRequestId = 0;

    /**
     * Constructor
     *
     * @param {ChatPanelService} _chatPanelService
     * @param {ProfileProvider} profileProvider
     * @param {FuseSidebarService} _fuseSidebarService
     */
    constructor(
        private _chatPanelService: ChatPanelService,
        private _fuseSidebarService: FuseSidebarService,
        private profileProvider: ProfileProvider,
        private _sanitizer: DomSanitizer,
        private rolePermissionService: RolePermissionService,
        private snackBarService: SnackBarService,
        private websocket: WebSocketService,
        private _pageVisibilityService: PageVisibilityService,
        private _matDialog: MatDialog
    ) {
        // Set the defaults
        this.selectedProfile = null;
        this.sidebarFolded = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.chatSearch = {
            name: "",
        };
        this.searchText = "";
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        this.websocket.reconnect
            .pipe(takeUntil(this._unsubscribeAll),
                debounceTime(500)
            ).subscribe({
                next: (rec) => {
                    this.findMessageNotReaded();

                }
            })
        this.rolePermissionService.userLogged
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500)
                // distinctUntilChanged()
            )
            .subscribe({
                next: (userLogged) => {
                    let profile = JSON.parse(userLogged);
                    if (this.isLogged == false) {
                        this.initChat();
                    }

                    if (profile?.id) {
                        const index = this.profileList.findIndex(p => p.id == profile.id);
                        if (index >= 0) {
                            this.profileList[index] = profile;
                        }
                        this.sortProfileList();
                    }


                },
                error: (err: any) => {
                    console.error(err);
                },
            });

        // Stream de realtime: NAO usar debounceTime aqui. O debounce agrupa os
        // frames e entrega so o ultimo, entao duas mensagens separadas por menos
        // de 500ms faziam a primeira sumir da lista. distinctUntilChanged segue
        // util porque descarta frames byte-a-byte iguais (reconexao do socket).
        this.rolePermissionService.chatMessageEvent
            .pipe(
                takeUntil(this._unsubscribeAll),
                distinctUntilChanged()
            )
            .subscribe({
                next: (chatMessage) => {
                    let message: Message = JSON.parse(chatMessage);

                    // Antes do getProfileByUserId resolver, "this.profile" e null
                    // e a comparacao abaixo derrubaria a tela.
                    if (!this.profile) {
                        return;
                    }

                    if (
                        message.profileTo.id == this.profile.id &&
                        message.profileFrom.id == this.selectedProfile?.id
                    ) {
                        if (!this.chat) {
                            this.chat = [];
                        }
                        // Rede de seguranca: o relay STOMP pode reentregar o mesmo
                        // frame (reconexao, reconfirmacao do broker) e, sem isto,
                        // a mensagem apareceria duas vezes na conversa.
                        if (!this.chat.some(m => m.id == message.id)) {
                            this.chat.push(message);
                        }
                        this.readedMessage(
                            this.selectedProfile.id,
                            this.profile.id
                        );
                        this._chatPanelService.playNotification();
                        this._prepareChatForReplies();
                    } else if (
                        message.profileTo.id == this.profile.id &&
                        message.profileFrom.id != this.selectedProfile?.id
                    ) {
                        const index = this.findIndexProfile(
                            message.profileFrom.id
                        );
                        if (index >= 0) {
                            // unread pode chegar null do backend; sem isto o
                            // contador viraria NaN e o badge sumia da lista.
                            const unread = (this.profileList[index].unread || 0) + 1;
                            this.profileList[index].unread = unread;
                            let title =
                                unread == 1
                                    ? `${unread} nova mensagem de:`
                                    : `${unread} novas mensagens de:`;
                            this._chatPanelService.playNotification();
                            this.snackBarService.notifierMessage(
                                "simpleMessage",
                                title,
                                Array(`${message.profileFrom.name}: ${message.message}`),
                                6000
                            );

                            if (!this._pageVisibilityService.isVisible()) {
                                this.snackBarService.ExternalNotification(
                                    `${title} ${message.profileFrom.name}`
                                );
                            }
                        }
                    }

                    this.sortProfileList();
                },
                error: (err: any) => {
                    console.error(err);
                },
            });

        this.rolePermissionService.updateProfileEvent
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (profileChat) => {
                    let profileChatTo: ProfileChatTo = JSON.parse(profileChat);
                    if (profileChatTo.profile.id != this.profile.id) {
                        const index = this.findIndexProfile(
                            profileChatTo.profile.id
                        );
                        if (index >= 0) {
                            this.profileList[index].status =
                                profileChatTo.status;
                            this.profileList[index].profile.name =
                                profileChatTo.profile.name;
                            this.profileList[index].avatar =
                                profileChatTo.avatar;
                        }
                    }
                    this.sortProfileList();
                },
                error: (err: any) => {
                    console.error(err);
                },
            });

        // // setTimeout(() => {
        // //     this.getUser();

        // // }, 2000);

        // // Load the contacts
        // // this._chatPanelService.loadContacts().then(() => {

        // //        this.user = this._chatPanelService.user;
        // //      const contacts = this._chatPanelService.contacts;
        // //       });

        // // Subscribe to the foldedChanged observable
        this._fuseSidebarService
            .getSidebar("chatPanel")
            .foldedChanged.pipe(takeUntil(this._unsubscribeAll))
            .subscribe((folded) => {
                this.sidebarFolded = folded;
            });
    }

    initChat() {
        this.getUserLogged();
        this.isLogged = true;
        this.getProfiles();
        this.sortProfileList();
    }

    openGroupMessage(): void {
        this._matDialog.open(DialogMessageComponent, {
            panelClass: 'clearPadding',
            data: { message: '', professionalId: null },
            width: '600px',
            maxWidth: '90vw',
        });
    }

    getUserLogged() {
        this.user = JSON.parse(localStorage.getItem("user"));
        if (this.user) {
            this.getProfileByUserId();
        }
    }
    getProfiles() {
        this.profileProvider.getProfileAll().then((res) => {
            this.profileList = res.body;
        });
    }

    findMessageNotReaded() {
        this.profileProvider.findMessageNotReaded(this.profile.id)
            .then(res => {
                if (CwUtils.checkStringIsNotNull(res.body)) {
                    this.snackBarService.notifierMessage(
                        "simpleMessage",
                        "Novas mensagens de: ",
                        Array(`${res.body}`),
                        6000
                    );
                     this._chatPanelService.playNotification();

                this.getProfiles();
                this.sortProfileList();
                }
               


            })
    }

    sortProfileList() {
        this.profileList.sort((profA, profB) => {
            let a = this._contactScore(profA);
            let b = this._contactScore(profB);

            return a == b ? 0 : a > b ? -1 : 1;
        });
    }

    /**
     * Pontuacao usada para ordenar a lista de contatos: quem tem mensagem nao
     * lida vem primeiro, e dentro disso por status (online, away, do-not-disturb,
     * offline). O score precisa ser calculado por um metodo separado porque o
     * comparator do Array.sort recebe os DOIS elementos - calcular "b" com dados
     * de "a" quebra o contrato da comparacao e deixa a ordem instavel.
     */
    private _contactScore(profile: ProfileChatTo): number {
        if (!profile) {
            return -1;
        }
        return (
            (profile.unread > 0 ? 5 : 0) +
            (profile.status == "online" ? 4 : 0) +
            (profile.status == "away" ? 3 : 0) +
            (profile.status == "do-not-disturb" ? 2 : 0) +
            (profile.status == "offline" && profile.unread > 0 ? 5 : -1)
        );
    }

    checkImagem(avatar) {
        let image = false;
        if (avatar != null) {
            // let imageFilter = personImagemList.filter(pi => pi.main === true);
            let imagePath = this._sanitizer.bypassSecurityTrustResourceUrl(
                "data:image/jpg;base64," + avatar
            );
            return imagePath;
        }
        return image;
    }

    /**
     * After view init
     */
    ngAfterViewInit(): void {
        this._chatViewScrollbar = this._fusePerfectScrollbarDirectives.find(
            (directive) => {
                return directive.elementRef.nativeElement.id === "messages";
            }
        );
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Prepare the chat for the replies
     */
    private _prepareChatForReplies(speed?): void {
        setTimeout(() => {
            // O replyInput so existe depois do ngAfterViewInit, e o resetChat()
            // pode tirar a conversa da tela entre a chamada e o setTimeout.
            if (!this._replyInput || !this.selectedProfile) {
                return;
            }

            // Focus to the reply input
            this._replyInput.nativeElement.focus();

            // Scroll to the bottom of the messages list
            if (this._chatViewScrollbar) {
                this._chatViewScrollbar.update();
                speed = speed || 400;
                setTimeout(() => {
                    this._chatViewScrollbar.scrollToBottom(0, speed);
                });
            }
        });
    }

    /**
     * Prepend older messages keeping the viewport anchored on the message that
     * was visible, so the conversation does not jump while the page loads.
     */
    private _prependMessages(messages: Message[]): void {
        const scrollbar = this._chatViewScrollbar;
        const element = scrollbar ? scrollbar.elementRef.nativeElement : null;
        const previousHeight = element ? element.scrollHeight : 0;
        const previousTop = element ? element.scrollTop : 0;

        this.chat = messages.concat(this.chat);

        if (!element) {
            return;
        }

        setTimeout(() => {
            scrollbar.update();
            element.scrollTop = previousTop + (element.scrollHeight - previousHeight);
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Fold the temporarily unfolded sidebar back
     */
    foldSidebarTemporarily(): void {
        this._fuseSidebarService.getSidebar("chatPanel").foldTemporarily();
        this.showChat = !this.showChat;
    }

    /**
     * Unfold the sidebar temporarily
     */
    unfoldSidebarTemporarily(): void {
        this._fuseSidebarService.getSidebar("chatPanel").unfoldTemporarily();
        if (this.showChat == false) {
            this.showChat = !this.showChat;
        }
    }

    /**
     * Toggle sidebar opened status
     */
    toggleSidebarOpen(): void {
        this._fuseSidebarService.getSidebar("chatPanel").toggleOpen();
    }

    /**
     * Decide whether to show or not the contact's avatar in the message row
     *
     * @param message
     * @param i
     * @returns {boolean}
     */
    shouldShowContactAvatar(message, i): boolean {
        return (
            message.profileFrom.id === this.selectedProfile.id &&
            ((this.chat[i + 1] &&
                this.chat[i + 1].profileFrom.id !== this.selectedProfile.id) ||
                !this.chat[i + 1])
        );
        // message.who === this.selectedProfile.id &&
        // ((this.chat.dialog[i + 1] && this.chat.dialog[i + 1].who !== this.selectedProfile.id) || !this.chat.dialog[i + 1])
    }

    /**
     * Check if the given message is the first message of a group
     *
     * @param message
     * @param i
     * @returns {boolean}
     */
    isFirstMessageOfGroup(message, i): boolean {
        return (
            i === 0 ||
            (this.chat[i - 1] &&
                this.chat[i - 1].profileFrom.id !== message.profileFrom.id)
        );
    }

    /**
     * Check if the given message is the last message of a group
     *
     * @param message
     * @param i
     * @returns {boolean}
     */
    isLastMessageOfGroup(message, i): boolean {
        return (
            i === this.chat.length - 1 ||
            (this.chat[i + 1] &&
                this.chat[i + 1].profileFrom.id !== message.profileFrom.id)
        );
    }

    findIndexProfile(profileId) {
        return this.profileList.findIndex((p) => p.id == profileId);
    }

    /**
     * trackBy das mensagens: sem isso o *ngFor recria todas as linhas a cada
     * mensagem que chega pelo socket ou a cada pagina prependida, e o Angular
     * perde o estado dos elementos que nao mudaram.
     */
    trackByMessage(index: number, message: Message): any {
        // O id e a chave natural. Sem ele (mensagem ainda nao persistida) a chave
        // cai para conteudo+data, e nao para o indice: ao carregar uma pagina
        // mais antiga todos os indices mudam e o trackBy por indice recriaria
        // a conversa inteira.
        return message && message.id != null ? message.id : `${message?.sended}-${message?.message}`;
    }

    /**
     * trackBy dos contatos da lista lateral.
     */
    trackByProfile(index: number, profile: ProfileChatTo): any {
        return profile ? profile.id : index;
    }
    /**
     * Toggle chat with the contact
     *
     * @param contact
     */
    async toggleChat(contact: ProfileChatTo): Promise<void> {
        const index = this.findIndexProfile(contact.id);
        if (index >= 0) {
            contact.unread = 0;
            this.profileList[index] = contact;
        }
        // If the contact equals to the selectedContact,
        // that means we will deselect the contact and
        // unload the chat
        if (this.selectedProfile && contact.id === this.selectedProfile.id) {
            // Reset
            this.resetChat();
        }
        // Otherwise, we will select the contact, open
        // the sidebar and start the chat
        else {
            // Unfold the sidebar temporarily
            this.unfoldSidebarTemporarily();

            // Set the selected contact
            this.selectedProfile = contact;

            // Load the last page of the chat
            this.chat = [];
            this.hasMoreMessages = true;
            this.loadMessages(false);
            // this._chatPanelService.getChat(contact.id).then((chat) => {

            // Set the chat
            //     this.chat = chat;

            //      // Prepare the chat for the replies
            //    this._prepareChatForReplies();
            //   });
        }
    }

    /**
     * Carrega uma pagina do historico da conversa aberta.
     *
     * @param older true para buscar as mensagens mais antigas que as ja
     *              carregadas, false para (re)carregar a pagina mais recente.
     */
    loadMessages(older: boolean): void {
        if (this.loadingMessages || !this.profile || !this.selectedProfile) {
            return;
        }

        if (older && !this.hasMoreMessages) {
            return;
        }

        // A mensagem mais antiga carregada e o cursor da pagina anterior.
        const cursor = older && this.chat.length ? this.chat[0] : null;
        if (older && !cursor) {
            return;
        }

        this.loadingMessages = true;
        const requestId = ++this._messagesRequestId;

        this.profileProvider
            .getMessagesPage(
                this.profile.id,
                this.selectedProfile.id,
                ChatPanelComponent.MESSAGE_PAGE_SIZE,
                cursor ? cursor.id : null,
                cursor ? cursor.sended : null
            )
            .then(
                (res) => {
                    this.loadingMessages = false;

                    // O usuario trocou de conversa enquanto a pagina carregava.
                    if (requestId !== this._messagesRequestId) {
                        return;
                    }

                    const page: MessagePage = res.body || { messages: [], hasMore: false };
                    this.hasMoreMessages = page.hasMore;

                    if (older) {
                        this._prependMessages(page.messages || []);
                    } else {
                        this.chat = page.messages || [];
                        this._prepareChatForReplies();
                        this.readedMessage(
                            this.selectedProfile.id,
                            this.profile.id
                        );
                    }
                },
                () => {
                    this.loadingMessages = false;
                }
            );
    }

    readedMessage(profileFrom, profileTo) {
        this._chatPanelService
            .readedMessage(profileFrom, profileTo)
            .then((res) => { });
    }

    getProfileByUserId() {
        return new Promise<any>((resolve, reject) => {
            this.profileProvider.getByUserId(this.user.id).then((res) => {
                this.profile = res.body;
            });
        });
    }

    /**
     * Remove the selected contact and unload the chat
     */
    resetChat(): void {
        // Invalida as paginas em voo da conversa anterior
        this._messagesRequestId++;

        // Set the selected contact as null
        this.selectedProfile = null;

        // Set the chat as null
        this.chat = null;

        this.hasMoreMessages = true;
        this.loadingMessages = false;
    }

    /**
     * Reply
     */
    reply(event): void {
        event.preventDefault();

        if (this.isSending || !this._replyForm || !this.selectedProfile || !this.profile) {
            return;
        }

        if (!this._replyForm.form.value.message) {
            return;
        }

        // Message
        let message = {
            id: null,
            profileFrom: CwUtils.extractId(this.profile),
            profileTo: CwUtils.extractId(this.selectedProfile),
            message: this._replyForm.form.value.message,
            sended: null,
            readed: null,
        };

        this.isSending = true;

        //send message
        this._chatPanelService.sendMessage(message).then((res) => {
            if (res.body) {
                // Add the message to the chat
                if (this.chat) {
                    this.chat.push(res.body);
                }
                this._replyForm.reset();
                this._prepareChatForReplies();
            }
            this.isSending = false;
        }, () => {
            this.isSending = false;
        });

        // Reset the reply form

        // Update the server
        // this._chatPanelService.updateChat(this.chat.id, this.chat.dialog).then(response => {

        //     // Prepare the chat for the replies
        //     this._prepareChatForReplies();
        // });
    }
}
